/* eslint-disable prefer-destructuring */

import apiHttpRequest from "services/api-http-request";
import chungohhhh1HttpRequest from "services/chungohhhh1-http-request";
import axios from 'axios';
import { isSchema } from "yup";

const getContainerActuatorDetail = async (actuatorId) => {
  
  const params = {};
  
  let detail = {};

  try {
    detail = await apiHttpRequest.get(`/container/actuator/${actuatorId}`, params);
  
  } catch (e) {
    console.error(e);
  }

  return detail
}

const getHouseAcTemp = async (acId) => {
  const params = {};

  let detail = {};

  let number = null;

  if (acId && acId.indexOf('_') > 0) {
    number = acId.split('_')[1];
  }

  if (number) {
    try {
      detail = await apiHttpRequest.get(`/house/actuator/airconditioner_temp_${number}`, params);
    } catch (e) {
      console.error(e);
    }
  }

  return detail
}

const getAirconditionData = async (acId) => {
  
  const params = {};
  const responses = [];
  const aircon = [];
  const times = [];
  const temps = [];
  const power = [];
  
  let number = null;

  if (acId && acId.indexOf('_') > 0) {
    number = acId.split('_')[1];
  }
  try {
    if (number) {
      
      const air1 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_STATION_1`, params);
      aircon.push(air1);
      const air2 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_STATION_2`, params);
      aircon.push(air2);
      const air3 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_STATION_3`, params);
      aircon.push(air3);
      const air4 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_STATION_4`, params);
      aircon.push(air4);
      const air5 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_STATION_5`, params);
      aircon.push(air5);

      const time1 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TIME_1`, params);
      times.push(time1);
      const time2 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TIME_2`, params);
      times.push(time2);
      const time3 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TIME_3`, params);
      times.push(time3);
      const time4 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TIME_4`, params);
      times.push(time4);
      const time5 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TIME_5`, params);
      times.push(time5);

      const temp1 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TEMP_1`, params);
      temps.push(temp1);
      const temp2 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TEMP_2`, params);
      temps.push(temp2);
      const temp3 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TEMP_3`, params);
      temps.push(temp3);
      const temp4 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TEMP_4`, params);
      temps.push(temp4);
      const temp5 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_AC_TEMP_5`, params);
      temps.push(temp5);

      const power1 = await apiHttpRequest.get(`/CONTAINER/actuator/${acId}`, params);
      power.push(power1);
    }
    responses.push(aircon);
    responses.push(times);
    responses.push(temps);
    responses.push(power);
  } catch (e) {
    console.error("에어컨 데이터 요청 실패:", e);
  }
  
  return responses;
};

const getChillerData = async (chillId) => {
  
  const params = {};
  const responses = [];
  const aircon = [];
  const times = [];
  const temps = [];
  const power = [];
  
  let number = null;

  if (chillId && chillId.indexOf('_') > 0) {
    number = chillId.split('_')[1];
  }
  try {
    if (number) {
      
      const air1 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_STATION_1`, params);
      aircon.push(air1);
      const air2 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_STATION_2`, params);
      aircon.push(air2);
      const air3 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_STATION_3`, params);
      aircon.push(air3);
      const air4 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_STATION_4`, params);
      aircon.push(air4);
      const air5 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_STATION_5`, params);
      aircon.push(air5);

      const time1 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TIME_1`, params);
      times.push(time1);
      const time2 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TIME_2`, params);
      times.push(time2);
      const time3 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TIME_3`, params);
      times.push(time3);
      const time4 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TIME_4`, params);
      times.push(time4);
      const time5 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TIME_5`, params);
      times.push(time5);

      const temp1 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TEMP_1`, params);
      temps.push(temp1);
      const temp2 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TEMP_2`, params);
      temps.push(temp2);
      const temp3 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TEMP_3`, params);
      temps.push(temp3);
      const temp4 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TEMP_4`, params);
      temps.push(temp4);
      const temp5 = await apiHttpRequest.get(`/CONTAINER/ACTUATOR/CNT_CHILLER_TEMP_5`, params);
      temps.push(temp5);

      const power1 = await apiHttpRequest.get(`/CONTAINER/actuator/${chillId}`, params);
      power.push(power1);
    }
    responses.push(aircon);
    responses.push(times);
    responses.push(temps);
    responses.push(power);
  } catch (e) {
    console.error("에어컨 데이터 요청 실패:", e);
  }

  
  return responses;
};

const updateContainerDevice = async (actuatorId, acPowerValue, sections) => {

  let device = null;
  
  const strPower = 'power';
  let isSuccess = true;

  if (actuatorId) {
    if (actuatorId === 'airconditioner_1') {
      device = 1;
    } else if (actuatorId === 'chiller_1') {
      device = 2;
    }

    // 에어컨 전원 api
    try {
      const response = await chungohhhh1HttpRequest.get(`/cntairconditioner/manual/device/${device}/state/${strPower}/value/${acPowerValue}`);
      if(response.result === 'fail'){
        isSuccess = false;
      }

      /* eslint-disable no-await-in-loop */
      for (let i = 0; i < sections.length; i++) {
        
        const data = sections[i];
        const used = data.isUsed;
        const gugan = data.section.split(' ')[1];
        

        if (used === 1) {
          
          const time = data.startTime.split(':')[0] + data.startTime.split(':')[1];
          const strtemp = data.temperature.toString();
          let temp='';
          let rtemp = '';
          if(strtemp.length <= 2){
            rtemp = strtemp+'0';
          }else{
            temp = data.temperature.split('.');
            rtemp = temp[0] + temp[1];
          }
          // let temp = '';
          // if (!data.temperature.includes('.')) {
          //   // 소수점이 없는 경우 뒤에 '.0'을 붙임
          //   temp = data.temperature + '0';
          // } else if (data.temperature.split('.')[1].length === 1) {
          //   // 소수점 뒤 숫자가 한자리인 경우 뒤에 '0'을 붙임
          //   temp = data.temperature + '0';
          // } else {
          //   // 기존 로직 처리
          //   temp = data.temperature.split('.')[0] + data.temperature.split('.')[1];
          // }
          // const temp = data.temperature.split('.')[0] + data.temperature.split('.')[1];

          const guganresponse = await chungohhhh1HttpRequest.get(`/cntairconditioner/section/control/device/${device}/state/${gugan}/value/${used}`);
          if(guganresponse.result === 'fail'){
            isSuccess = false;
          }
          const timeresponse = await chungohhhh1HttpRequest.get(`/cntairconditioner/section/time/device/${device}/state/${gugan}/value/${time}`);
          if(timeresponse.result === 'fail'){
            isSuccess = false;
          }
          const tempresponse = await chungohhhh1HttpRequest.get(`/cntairconditioner/section/temp/device/${device}/state/${gugan}/value/${rtemp}`);
          if(tempresponse.result === 'fail'){
            isSuccess = false;
          }

        } else {
          
          const elseresponse = await chungohhhh1HttpRequest.get(`/cntairconditioner/section/control/device/${device}/state/${gugan}/value/${used}`);
          if(elseresponse.result === 'fail'){
            isSuccess = false;
          }
        }
      }

    } catch (e) {
      console.error(e);
      isSuccess = false;
    }
  }

  

  if (isSuccess) {
    return { state: 'success' };
  } else {
    return { state: 'fail', error_message: 'Some operations failed.' };
  }
};



export default {
  getContainerActuatorDetail,
  getAirconditionData,
  getChillerData,
  getHouseAcTemp,
  updateContainerDevice

}